export const Bata1 = require("./bata-1.jpeg");
export const Bata2 = require("./bata-2.jpeg");